<div class="container">
  <div class="table-background">
    <div class="row">
      <div class="search-row">
        <form role="search" class="em-c-search-form filterFormClass" [formGroup]="filterForm">
          <div class="em-c-search__body">
            <input id="search" type="search" class="em-c-search__input" placeholder="Search by keywords" value=""
              formControlName="search" />
            <button class="em-c-btn em-c-btn--primary search" aria-label="Search">
              <div class="em-c-btn__inner">
                <svg class="em-c-icon em-c-icon--small  em-c-btn__icon">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="images/16/em-icons.svg#search"></use>
                </svg>
              </div>
            </button>
          </div>

          <div class="em-c-field searchDropdown">
            <label for="select" class="em-c-field__label" id="labelSelect">Location:</label>
            <div class="em-c-field__body">
              <select class="em-c-select countrySelect" [(ngModel)]="countryValue" id="country"
                aria-labelledby="labelSelect" aria-describedby="descSelect" placeholder="Select Country"
                formControlName="country" (change)=OnCountryChange($event)>
                @for (country of countries; track $index) {
                <option [value]="country.countryName">{{country.countryName}}</option>
                }
              </select>
            </div>
          </div>

          <div class="em-c-field searchDropdown">
            <label for="select" class="em-c-field__label" id="labelSelect">Well:</label>
            <div class="em-c-field__body">
              <select class="em-c-select wellSelect" [(ngModel)]="wellValue" id="well" aria-labelledby="labelSelect"
                aria-describedby="descSelect" placeholder="Select well" formControlName="well">
                @for (well of wellsLookup; track $index) {
                <option [value]="well.wellName">{{well.wellName}}</option>
                }
              </select>
            </div>
          </div>

          <div class="em-c-field searchDropdown">
            <label for="select" class="em-c-field__label" id="labelSelect">Status:</label>
            <div class="em-c-field__body">
              <select class="em-c-select statusSelect" [(ngModel)]="statusValue" id="status"
                aria-labelledby="labelSelect" aria-describedby="descSelect" placeholder="Select status"
                formControlName="status">
                @for (status of statusLookup; track $index) {
                <option [value]="status.statusName">{{status.statusName}}</option>
                }
              </select>
            </div>
          </div>

          <div class="em-c-field em-c-field--small searchDropdown" formGroupName="dateRange">
            <label for="dateRange" class="em-c-field__label">Date range:</label>
            <div class="em-c-field__body">
              <mat-form-field appearance="outline" class="datepicker">
                <mat-date-range-input [rangePicker]="rangepicker">
                  <input matStartDate placeholder="Start date" class="datepickerClass" id="startDateInput"
                    formControlName="start" readonly>
                  <input matEndDate placeholder="End date" class="datepickerClass" id="endDateInput"
                    formControlName="end" readonly>
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="rangepicker"></mat-datepicker-toggle>
                <mat-date-range-picker #rangepicker></mat-date-range-picker>
              </mat-form-field>
            </div>
          </div>

          <button class="em-c-btn em-c-btn--secondary em-c-btn--small resetButton" (click)="ResetFilters()">
            <span class="em-c-btn__text">Reset filters</span>
          </button>
          @if (roleId === roleIds.fluidEngineer) {
          <button type="button" class="em-c-btn em-c-btn--primary em-js-modal-trigger add-sample"
            (click)="NavigateCreateProject()">
            <div class="em-c-btn__inner">
              <span class="em-c-btn__text">Create new project</span>
            </div>
          </button>
          }
          @if (roleId === roleIds.fluidEngineer || roleId === roleIds.techResource) {
          <button type="button" class="em-c-btn em-c-btn--primary em-js-modal-trigger add-sample"
            (click)="GenerateUserReport()">
            <div class="em-c-btn__inner">
              <span class="em-c-btn__text">Monthly report</span>
            </div>
          </button>
          }
        </form>
      </div>
    </div>

    <div class="charts-row">
      <div class="chart-card">
        <h4 class="chart-title">Project overview</h4>
        @if (dataSource.data.length === 0) {
        <div class="no-chart-data">No data</div>
        } @else {
        <canvas id="statusPieChart" #statusPieChart></canvas>
        }
      </div>

      <div class="chart-card">
        <h4 class="chart-title d-inline-block">Well wise Projects</h4>
        @if (chartLegendListAll.length !== 0) {
        <a class="btn-more" (click)="OpenLegendDialog()" (keyup.enter)="OpenLegendDialog()" tabindex="0" role="button">
          More...
        </a>
        }
        @if (dataSource.data.length === 0) {
        <div class="no-chart-data">No data</div>
        } @else {
        <canvas id="wellPieChart" #wellPieChart></canvas>
        }
      </div>
    </div>

    <div class="main-table overflow-auto">
      <table class="em-c-table t-body-height" mat-table matSort #table [dataSource]="dataSource"
        matSortActive="wellName" matSortDirection="asc" #outerSort="matSort" multiTemplateDataRows>

        <!-- Well Name -->
        <ng-container matColumnDef="wellName">
          <mat-header-cell *matHeaderCellDef mat-sort-header="wellName">Well</mat-header-cell>
          <mat-cell *matCellDef="let element; let idx = dataIndex" (click)="ToggleRow(element, idx)" class="toggle">
            <svg class="em-c-icon em-c-icon--small em-c-table__icon right-chevron"
              [ngClass]="{ 'rotated': rotatedIndex === idx }">
              <use xlink:href="images/16/em-icons.svg#chevron-right-filled"></use>
            </svg>
            {{ element.wellName }}
          </mat-cell>
        </ng-container>

        <!-- Location -->
        <ng-container matColumnDef="location">
          <mat-header-cell *matHeaderCellDef mat-sort-header="location">Location</mat-header-cell>
          <mat-cell *matCellDef="let element; let idx = dataIndex" (click)="ToggleRow(element, idx)" class="toggle">
            {{ element.location }}
          </mat-cell>
        </ng-container>

        <!-- Project Count -->
        <ng-container matColumnDef="projectCount">
          <mat-header-cell *matHeaderCellDef>Projects</mat-header-cell>
          <mat-cell *matCellDef="let element; let idx = dataIndex" (click)="ToggleRow(element, idx)" class="toggle">
            {{ element.projects?.length || 0 }}
          </mat-cell>
        </ng-container>

        <!-- Expanded Detail Row -->
        <ng-container matColumnDef="expandedDetail">
          <mat-cell *matCellDef="let element" [attr.colspan]="displayColumns.length">
            @if (element.projects?.length) {
            <div [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
              @if (expandedElement === element) {
              <div class="inner-table">
                <table class="em-c-table t-body-inner-height" mat-table #innerTables [dataSource]="element.projects"
                  #innerSort="matSort" matSort>

                  <ng-container matColumnDef="projectNumber">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="projectNumber">Project Number</mat-header-cell>
                    <mat-cell *matCellDef="let p" class="cursor-pointer">{{ p.projectNumber }}</mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="projectName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="projectName">Project Name</mat-header-cell>
                    <mat-cell *matCellDef="let p" class="cursor-pointer">{{ p.projectName }}</mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="buContact">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="buContact">BU Contact</mat-header-cell>
                    <mat-cell *matCellDef="let p" class="cursor-pointer">{{ p.buContact }}</mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="leadEngineer">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="leadEngineer">Lead Engineer</mat-header-cell>
                    <mat-cell *matCellDef="let p" class="cursor-pointer">{{ p.leadEngineer }}</mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="createdBy">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="createdBy">Created By</mat-header-cell>
                    <mat-cell *matCellDef="let p" class="cursor-pointer">{{ p.createdBy }}</mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="status">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
                    <mat-cell *matCellDef="let p" class="status-cell">
                      <span class="em-c-badge" [ngClass]="(p?.status).toUpperCase()=== STATUS_CONSTANTS_UC.Completed
                            ? 'em-c-badge em-c-badge--positive'
                            : (p?.status).toUpperCase() === STATUS_CONSTANTS_UC.Ready
                            ? 'em-c-badge--ready'
                            :'em-c-badge em-c-badge--caution'" role="status" tabindex="0"
                        [attr.aria-label]="(p?.status).toUpperCase()">
                        {{ p?.status | uppercase }}
                      </span>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="action">
                    <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
                    <mat-cell *matCellDef="let element" [class.example-element-row]="element.projects?.length"
                      [class.example-expanded-row]="expandedElement === element" (click)="$event.stopPropagation()">

                      @if(roleId === roleIds.labTech || roleId === roleIds.techResource){
                      <button class="em-c-btn action-button action-button-disabled" aria-label="Icon button"
                        title="Complete Project" (click)="CompleteProject(element)"
                        [disabled]="(roleId===roleIds.labTech || roleId === roleIds.techResource)">
                        <div class="em-c-btn__inner">
                          <svg class="em-c-icon em-c-icon--small  em-c-btn__icon">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="images/16/em-icons.svg#check">
                            </use>
                          </svg>
                        </div>
                      </button>}
                      @else {
                      <button class="em-c-btn action-button" aria-label="Icon button" title="Complete Project"
                        (click)="CompleteProject(element)">
                        <div class="em-c-btn__inner">
                          <svg class="em-c-icon em-c-icon--small  em-c-btn__icon">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="images/16/em-icons.svg#check">
                            </use>
                          </svg>
                        </div>
                      </button>
                      }

                      @if(element?.labTestListData.count === 0 || (element?.status)?.toUpperCase()!==
                      STATUS_CONSTANTS_UC.Completed || roleId===roleIds.labTech){
                      <button
                        [disabled]="(element?.status)?.toUpperCase()!== STATUS_CONSTANTS_UC.Completed || roleId===roleIds.labTech"
                        class="em-c-btn em-js-modal-trigger action-button action-button-disabled"
                        aria-label="Icon button" title="Generate Report" (click)="OpenGenerateReportPopup(element)">
                        <div class="em-c-btn__inner">
                          <svg class="em-c-icon em-c-icon--small  em-c-btn__icon">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink"
                              xlink:href="images/16/em-icons.svg#download"></use>
                          </svg>
                        </div>
                      </button>}
                      @else {
                      <button class="em-c-btn action-button" aria-label="Icon button" title="Generate Report"
                        (click)="OpenGenerateReportPopup(element)">
                        <div class="em-c-btn__inner">
                          <svg class="em-c-icon em-c-icon--small  em-c-btn__icon">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink"
                              xlink:href="images/16/em-icons.svg#download"></use>
                          </svg>
                        </div>
                      </button>
                      }
                      @if(element?.labTestListData.count === 0 || (element?.status)?.toUpperCase()!==
                      STATUS_CONSTANTS_UC.Completed || roleId===roleIds.labTech){
                      <button class="em-c-btn action-button action-button-disabled" aria-label="Icon button"
                        title="Generate RFPOD Report" (click)="GenerateRFPODReport(element)"
                        [disabled]="(element?.status)?.toUpperCase()!== STATUS_CONSTANTS_UC.Completed || roleId===roleIds.labTech">
                        <div class="em-c-btn__inner">
                          <svg class="em-c-icon em-c-icon--small  em-c-btn__icon" alt="RFPOD Report">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink"
                              xlink:href="images/16/em-icons.svg#file-xlsx">
                            </use>
                          </svg>
                        </div>
                      </button>
                      }
                      @else{
                      <button class="em-c-btn action-button" aria-label="Icon button" title="Generate RFPOD Report"
                        (click)="GenerateRFPODReport(element)">
                        <div class="em-c-btn__inner">
                          <svg class="em-c-icon em-c-icon--small  em-c-btn__icon" alt="Generate RFPOD Report">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink"
                              xlink:href="images/16/em-icons.svg#file-xlsx"></use>
                          </svg>
                        </div>
                      </button>
                      }
                      <button class="em-c-btn action-button" aria-label="Icon button"
                        title="Generate Comments History Report" (click)="GenerateCommentsHistoryReport(element)">
                        <div class="em-c-btn__inner">
                          <svg class="em-c-icon em-c-icon--small  em-c-btn__icon">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink"
                              xlink:href="images/16/em-icons.svg#file-pdf-2"></use>
                          </svg>
                        </div>
                      </button>
                    </mat-cell>
                  </ng-container>

                  <thead>
                    <mat-header-row *matHeaderRowDef="innerDisplayedColumns"></mat-header-row>
                  </thead>
                  @if(roleId===roleIds.labTech){
                  <mat-row (click)="NavigateProjectDetail(row)"
                    *matRowDef="let row;columns: innerDisplayedColumns;let i = index">
                  </mat-row>
                  }
                  @else if (roleId===roleIds.fluidEngineer) {
                  <mat-row (click)="NavigateProjectDetail(row)"
                    *matRowDef="let row;columns: innerDisplayedColumns;let i = index">
                  </mat-row>
                  }
                  @else if (roleId===roleIds.techResource) {
                  <mat-row (click)="NavigateProjectDetail(row)"
                    *matRowDef="let row;columns: innerDisplayedColumns;let i = index">
                  </mat-row>
                  }
                </table>
              </div>
              }
            </div>
            }
          </mat-cell>
        </ng-container>

        <thead>
          <mat-header-row *matHeaderRowDef="displayColumns"></mat-header-row>
        </thead>
        <mat-row *matRowDef="let element; columns: displayColumns"></mat-row>
        <mat-row *matRowDef="let row; columns: ['expandedDetail']"
          [ngClass]="row === expandedElement ? '' : 'no-display'"></mat-row>
      </table>
      @if (dataSource.data.length === 0) {
      <div class="no-records-cell">No records found</div>
      }

      <div class="paginator">
        <mat-paginator #paginator [length]="dataSource.data.length" [pageSize]="pageEvent.pageSize"
          [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = $event">
        </mat-paginator>
      </div>
    </div>
    <div>
      <canvas id="bubblePointChart" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="bubblePointChart1" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="bubblePointChart2" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="bubblePointChart3" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="bubblePointChart4" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="plotOilChart1" #plotOilChart1 [attr.width]="canvasWidth" [attr.height]="canvasHeight"
        [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="plotOilChart2" #plotOilChart2 [attr.width]="canvasWidth" [attr.height]="canvasHeight"
        [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="MatarialBalance" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="MatarialBalanceResult" [attr.width]="canvasWidth" [attr.height]="canvasHeight" #MatarialBalanceResult
        [ngStyle]="{ display: graphDisplay ? 'block' : 'none'}"></canvas>
      <canvas id="HoffmanFactor" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="HoffmanFactorResult" #HoffmanFactorResult [attr.width]="canvasWidth" [attr.height]="canvasHeight"
        [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="ViscosityChart" #viscosityChart [attr.width]="canvasWidth" [attr.height]="canvasHeight"
        [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="cceDewPointChart1" #cceDewPointChart1 [attr.width]="canvasWidth" [attr.height]="canvasHeight"
        [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="cceDewPointChart2" #cceDewPointChart2 [attr.width]="canvasWidth" [attr.height]="canvasHeight"
        [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="decontDeadOilChart" #decontDeadOilChart class="decontamination"
        [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="decontliveFluidChart" #decontliveFluidChart class="decontamination"
        [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="summaryOfCCEChart" #summaryOfCCEChart [attr.width]="canvasWidth" [attr.height]="canvasHeight"
        [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="swellingChart" #swellingChart [attr.width]="canvasWidth" [attr.height]="canvasHeight"
        [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
    </div>
  </div>
</div>
<ng-template #legendDialog let-dialogRef="dialogRef">
  <div class="em-c-modal wellLegend" role="alertdialog" aria-modal="true" aria-labelledby="modalTitle"
    aria-describedby="modalDescription">
    <section class="em-c-modal__window">
      <div class="em-c-modal__header mb-0" tabindex="0">
        <div>
          <div class="em-c-modal__title" id="modalTitle">
            <!-- Legend List -->
          </div>
        </div>
        <button [mat-dialog-close]="false" class="em-c-btn em-c-btn--bare em-c-modal__close-btn" title="Close modal"
          aria-label="Button name">
          <div class="em-c-btn__inner">
            <svg class="em-c-icon em-c-icon--small  em-c-btn__icon">
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="images/16/em-icons.svg#x-filled"></use>
            </svg>
          </div>
        </button>
      </div>
      <div class="em-c-modal__body" id="modalDescription">
        <ul>
          @for(item of PaginatedData; track item.text) {
          <li>
            <span class="legend-color" [style.background-color]="item.fillStyle"></span>
            <div>
              <span class="legend-name">{{ sharedService.GetName(item.text) }}</span>
              <span class="legend-value">{{ sharedService.GetValue(item.text) }}</span>
            </div>
          </li>
          }
        </ul>
      </div>
      <div class="paginator">
        <mat-paginator #paginator1 [length]="dataSource.data.length" [pageSize]="pageEvent1.pageSize"
          [pageSizeOptions]="pageSizeOptions" (page)="pageEvent1 = $event">
        </mat-paginator>
      </div>
    </section>
    <div class="em-c-modal__overlay em-is-closed"></div>
  </div>
</ng-template>

<ng-template #legendDialogPrivew let-dialogRef="dialogRef">
  <div class="em-c-modal previewModel" role="alertdialog" aria-modal="true" aria-labelledby="modalTitle"
    aria-describedby="modalDescription">
    <section class="em-c-modal__window">
      <div class="em-c-modal__header mb-0" tabindex="0">
        <div>
          <div class="em-c-modal__title" id="modalTitle">
            <!-- Legend List -->
          </div>
        </div>
        <button [mat-dialog-close]="false" class="em-c-btn em-c-btn--bare em-c-modal__close-btn" title="Close modal"
          aria-label="Button name">
          <div class="em-c-btn__inner">
            <svg class="em-c-icon em-c-icon--small  em-c-btn__icon">
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="images/16/em-icons.svg#x-filled"></use>
            </svg>
          </div>
        </button>
      </div>
      <div class="em-c-modal__body">

        @if (pdfData) {
        <div class="pdf-toolbar">

          <div class="toolbar-section">
            <button type="button" class="toolbar-btn" (click)="prevPage()" [disabled]="page === 1">
              ◀
            </button>

            <span class="page-info">
              Page {{ page }} of {{ totalPages }}
            </span>

            <button type="button" class="toolbar-btn" (click)="nextPage()" [disabled]="page === totalPages">
              ▶
            </button>
          </div>

          <div class="toolbar-divider"></div>

          <div class="toolbar-section">
            <button type="button" class="toolbar-btn" (click)="zoomOut()">
              −
            </button>

            <span class="zoom-info">
              {{ zoom * 100 | number:'1.0-0' }}%
            </span>

            <button type="button" class="toolbar-btn" (click)="zoomIn()">
              +
            </button>
          </div>

        </div>
        <div class="pdf-viewer-wrapper">

          <pdf-viewer [src]="pdfData" [show-all]="true" [zoom]="zoom" [render-text]="true" [(page)]="page"
            class="pdf-viewer-display" (after-load-complete)="onPdfLoadComplete($event)">
          </pdf-viewer>

        </div>



        }

      </div>
    </section>
    <div class="em-c-modal__overlay em-is-closed"></div>
  </div>
</ng-template>